import { Typography } from "@mui/material";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
}

export default function SectionHeader({ title, subtitle }: SectionHeaderProps) {
  return (
    <>
      <Typography 
        variant="h2" 
        fontWeight="bold" 
        sx={{ 
          mb: { xs: 1.5, md: 2 },
          fontSize: { xs: "1.75rem", md: "2.25rem" },
          lineHeight: 1.25
        }}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography 
          variant="subtitle1" 
          color="text.secondary" 
          sx={{ 
            mb: { xs: 3, md: 4 }, 
            lineHeight: 1.6,
            fontSize: { xs: "1rem", md: "1.125rem" }
          }}
        >
          {subtitle}
        </Typography>
      )}
    </>
  );
}
